module.exports = __webpack_public_path__ + "static/media/baixeagora.fd62cad3.svg";